
// export const VEH_IMAGE_URL = 'http://127.0.0.1:8000/veh_images/';
// export const VEH_AGREEMENT_URL = 'http://127.0.0.1:8000';
// export const APP_URL = "http://127.0.0.1:8000/";
// export const BASE_URL = 'http://127.0.0.1:8000/api';
// export const INV_ATTACHEMEN_URL = 'http://127.0.0.1:8000/inv_attachements/';


export const VEH_IMAGE_URL = 'https://vertex-new.qwpcorp.com/vertex_backend_new/public/veh_images/';
export const INV_ATTACHEMEN_URL = 'https://vertex-new.qwpcorp.com/vertex_backend_new/public/inv_attachements/';
export const VEH_AGREEMENT_URL = 'https://vertex-new.qwpcorp.com/vertex_backend_new/public';
export const APP_URL = "https://vertex-new.qwpcorp.com/vertex_backend_new/public/";
export const BASE_URL = 'https://vertex-new.qwpcorp.com/vertex_backend_new/public/api';